import React, { useEffect, useState } from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronLeft } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import PageContainer from 'components/PageContainer/PageContainer';
import Spinner from 'components/public/Spinner/Spinner';
import RespuestaServidor from 'pages/auxiliares/RespuestaServidor';
import { alturaContainer, anchoMaxForms } from 'utils/constants';
import CaratulaObra from '../FichaEspectaculo/CaratulaObra';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { fetchTallerPorId } from 'utils/redux/features/tallerIdSlice';
import InformacionTaller from './InformacionTaller';
import NoImage from 'assets/afichesObras/No-image.jpg';

const FichaTaller = () => {
  const { id } = useParams();
  const { taller, loadingTaller, errorTaller } = useSelector((state: RootState) => state.taller);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [imgSrc, setImgSrc] = useState<string>('');
  const afiche = String(taller?.AficheUrl);

  useEffect(() => {
    id && dispatch(fetchTallerPorId(Number(id)));
  }, [id, dispatch]);

  useEffect(() => {
    if (!loadingTaller) {
      const img = new Image();
      img.src = afiche;
      img.onload = () => setImgSrc(afiche);
      img.onerror = () => setImgSrc(NoImage);
    }
  }, [afiche]);

  return (
    <PageContainer sx={{ paddingBottom: '50px', minHeight: alturaContainer }} marginBottom={true}>
      {loadingTaller ? (
        <Spinner />
      ) : !errorTaller ? (
        <Box ml={2} textAlign="left" maxWidth={anchoMaxForms} px={{ xs: 0, lg: 10 }}>
          <Button fullWidth={false} sx={{ mb: 2 }} onClick={() => navigate(-1)} startIcon={<ChevronLeft />}>
            Volver
          </Button>
          <Box flex="1" display="flex" gap={{ xs: 3, lg: 6 }} justifyContent="space-evenly">
            <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={{ xs: 3, lg: 6 }} textAlign="center">
              <CaratulaObra afiche={imgSrc} nombre={taller.Nombre.toUpperCase()} inscripcion />
              <InformacionTaller taller={taller} />
            </Box>
          </Box>
        </Box>
      ) : (
        <RespuestaServidor
          titulo="Error del servidor"
          texto={`No se pudo cargar el taller. Intentalo de nuevo más tarde o contactate con un administrador del sitio.`}
          icono={ErrorOutlineIcon}
          textoBoton="Reintentar"
          colorIcono="error"
          paginaANavegar={0}
        />
      )}
    </PageContainer>
  );
};

export default FichaTaller;
